import Job from 'models/Job';

import Component from './component';


export interface Props {
jobs: Job[];
jobsCopy:{
    title:string;
};
iconsAlts?: {
    agreement?: string;
    time?: string;
    location?: string;
    arrow?: string;
}
}


export default Component;